<template>
  <div class="hello" id="container">
    <div class="stage_title--sub" v-if="isBusy">
      <b-spinner style="color: #93bc79;" label="Spinning"></b-spinner>
    </div>
    <div class="stage_title--sub" v-else-if="!isBusy && !error">
      <b-icon icon="check-circle" style="width: 120px; height: 120px; color: #93bc79;"></b-icon>
      <h1>{{ heading }}</h1>
      <p v-for="line in body" :key="line.message" :class="line.format">{{ line.message }}</p>
      <p>{{ footer }}</p>
    </div>
    <div class="stage_title--sub" v-else-if="!isBusy && error">
      <h1>{{ errorHeading }}</h1>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { csbpApi } from '@/config/index.js';
export default {
  name: 'SolvedTicket',
  props: {
    siteName: String,
    ticketId: String,
    language: String,
    requesterId: String,
    cancel: Boolean,
  },
  data: () => ({
    heading: '',
    body: [],
    footer: '',
    errorHeading: '',
    errorMessage: '',
    error: false,
    email: undefined,
    referenceNumber: undefined,
    cancelDate: undefined,
    isBusy: true,
  }),

  async mounted() {
    window.addEventListener('resize', this.resizeWindow);
    await this.cancelMember();
    this.resizeWindow();
  },
  methods: {
    resizeWindow() {
      let newHeight = document.getElementById('container') && document.getElementById('container').scrollHeight ? `${Math.max(document.getElementById('container').scrollHeight, 250)}px` : '600px';
      if (window.parent) {
        window.parent.postMessage({ height: newHeight }, '*');
      }
    },
    messageLanguage() {
      let message = {
        'en-us': {
          errorHeading: `Something went wrong`,
          errorMessage: `Sorry, it appears we are having some technical difficulties.`,
          heading: `Your account has been cancelled effective immediately`,
          body: [
            { format: 'body-padding', message: `Your ${this.siteName ? `${this.siteName}` : ``} membership has been successfully cancelled and your card will no longer be charged` },
            { format: 'body', message: `We've also sent a confirmation email to${this.email ? `: ${this.email}` : ` your email address`}` },
            { format: 'body-padding', message: `If you do not receive your email within a few minutes please check your spam/junk folder` },
            { format: 'bolder', message: `${this.referenceNumber ? `Reference number: ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `Cancel Date:  ${this.cancelDate}` : ``}` },
            { format: 'body', message: `Your ticket ${this.ticketId ? this.ticketId : ''} is now solved` },
          ],
          footer: 'If you need any further assistance, please contact us',
        },
        fr: {
          errorHeading: `Un problème est survenu`,
          errorMessage: `Désolé, il semble que nous ayons des difficultés techniques.`,
          heading: `Votre compte a été annulé avec effet immédiat`,
          body: [
            {
              format: 'body-padding',
              message: this.siteName
                ? `Ton L'adhésion à ${this.siteName} a été annulée avec succès et votre carte ne sera plus débitée`
                : `Votre adhésion a été annulée avec succès et votre carte ne sera plus débitée`,
            },
            {
              format: 'body',
              message: this.email ? `Nous avons également envoyé un e-mail de confirmation à: ${this.email}` : `Nous avons également envoyé un e-mail de confirmation à votre adresse e-mail`,
            },
            { format: 'body-padding', message: `Si vous ne recevez pas votre e-mail dans quelques minutes, veuillez vérifier votre dossier spam / courrier indésirable` },
            { format: 'bolder', message: `${this.referenceNumber ? `Numéro de réference: ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `Date d'annulation:  ${this.cancelDate}` : ``}` },
            { format: 'body', message: this.ticketId ? `Votre ticket ${this.ticketId} est maintenant résolu` : `Votre ticket est maintenant résolu` },
          ],
          footer: `Si vous avez besoin d'une assistance supplémentaire, veuillez nous contacter`,
        },
        it: {
          errorHeading: `Qualcosa è andato storto`,
          errorMessage: `Siamo spiacenti, sembra che stiamo avendo delle difficoltà tecniche.`,
          heading: `Il tuo account è stato cancellato con effetto immediato`,
          body: [
            {
              format: 'body-padding',
              message: this.siteName
                ? `La tua iscrizione a ${this.siteName} è stata annullata con successo e la tua carta non verrà più addebitata`
                : `La tua iscrizione è stata annullata con successo e la tua carta non verrà più addebitata`,
            },
            {
              format: 'body',
              message: this.email ? `Abbiamo anche inviato un'e-mail di conferma a: ${this.email}` : `Abbiamo anche inviato un'e-mail di conferma al tuo indirizzo e-mail`,
            },
            { format: 'body-padding', message: `Se non ricevi la tua email entro pochi minuti, controlla la tua cartella spam / posta indesiderata` },
            { format: 'bolder', message: `${this.referenceNumber ? `Numero di riferimento: ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `Data di annullamento:  ${this.cancelDate}` : ``}` },
            { format: 'body', message: this.ticketId ? `Il tuo ticket ${this.ticketId} è ora risolto` : `Il tuo ticket è ora risolto` },
          ],
          footer: `Se hai bisogno di ulteriore assistenza, contattaci`,
        },
        ja: {
          errorHeading: `何かがうまくいかなかった`,
          errorMessage: `申し訳ありませんが、技術的な問題が発生しているようです。`,
          heading: `アカウントはすぐにキャンセルされました`,
          body: [
            {
              format: 'body-padding',
              message: this.siteName ? `${this.siteName}メンバーシップは正常にキャンセルされ、カードへの請求は行われません。` : `メンバーシップは正常にキャンセルされ、カードへの請求は行われません。`,
            },
            {
              format: 'body',
              message: this.email ? `また、${this.email}に確認メールを送信しました。` : `また、あなたのメールアドレスに確認メールを送信しました`,
            },
            { format: 'body-padding', message: `数分以内にメールが届かない場合は、スパム/ジャンクフォルダを確認してください` },
            { format: 'bolder', message: `${this.referenceNumber ? `参照番号： ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `キャンセル日： ${this.cancelDate}` : ``}` },
            { format: 'body', message: this.ticketId ? `チケット${this.ticketId}が解決されました` : `チケットが解決されました` },
          ],
          footer: `さらにサポートが必要な場合は、お問い合わせください`,
        },
        pt: {
          errorHeading: `Algo deu errado`,
          errorMessage: `Desculpe, parece que estamos com algumas dificuldades técnicas.`,
          heading: `Sua conta foi cancelada com efeito imediato`,
          body: [
            {
              format: 'body-padding',
              message: this.siteName
                ? `Sua assinatura do ${this.siteName} foi cancelada com sucesso e seu cartão não será mais cobrado`
                : `Sua assinatura foi cancelada com sucesso e seu cartão não será mais cobrado`,
            },
            {
              format: 'body',
              message: this.email ? `Também enviamos um e-mail de confirmação para: ${this.email}` : `Também enviamos um e-mail de confirmação para o seu endereço de e-mail`,
            },
            { format: 'body-padding', message: `Se você não receber seu e-mail em alguns minutos, verifique sua pasta de spam / lixo` },
            { format: 'bolder', message: `${this.referenceNumber ? `Número de referência: ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `Data de cancelamento:  ${this.cancelDate}` : ``}` },
            { format: 'body', message: this.ticketId ? `Seu tíquete ${this.ticketId} agora está resolvido` : `Seu tíquete está resolvido` },
          ],
          footer: `Se precisar de mais ajuda, entre em contato conosco`,
        },
        es: {
          errorHeading: `Algo salió mal`,
          errorMessage: `Lo sentimos, parece que estamos teniendo algunas dificultades técnicas.`,
          heading: `Su cuenta ha sido cancelada con efecto inmediato`,
          body: [
            {
              format: 'body-padding',
              message: this.siteName
                ? `Su membresía de ${this.siteName} ha sido cancelada con éxito y ya no se le cobrará a su tarjeta`
                : `Su membresía ha sido cancelada con éxito y ya no se le cobrará a su tarjeta`,
            },
            {
              format: 'body',
              message: this.email
                ? `También hemos enviado un correo electrónico de confirmación a: ${this.email}`
                : `También hemos enviado un correo electrónico de confirmación a su dirección de correo electrónico.`,
            },
            { format: 'body-padding', message: `Si no recibe su correo electrónico en unos minutos, verifique su carpeta de correo no deseado / basura` },
            { format: 'bolder', message: `${this.referenceNumber ? `Número de referencia: ${this.referenceNumber}` : ''}` },
            { format: 'bolder body-padding', message: `${this.cancelDate ? `Fecha de cancelación:  ${this.cancelDate}` : ``}` },
            { format: 'body', message: this.ticketId ? `Su ticket ${this.ticketId} ya está resuelto` : `Tu ticket ya está resuelto` },
          ],
          footer: `Si necesita más ayuda, comuníquese con nosotros.`,
        },
      };
      let resultMessage = message[this.language];
      if (!resultMessage) {
        resultMessage = message['en-us'];
      }
      this.heading = resultMessage.heading;
      this.body = resultMessage.body;
      this.footer = resultMessage.footer;
      this.errorHeading = resultMessage.errorHeading;
      this.errorMessage = resultMessage.errorMessage;
      return;
    },
    populateUserValues(data = {}) {
      this.referenceNumber = data.cancelMemberResponse && data.cancelMemberResponse.data && data.cancelMemberResponse.data.ticketId ? data.cancelMemberResponse.data.ticketId : undefined;
      this.email = data.requester && data.requester.email ? data.requester.email : undefined;
    },
    async cancelMember() {
      if (!this.ticketId || !this.requesterId || !this.cancel) {
        throw new Error('Invalid request');
      }
      try {
        let response = await axios.post(
          `${csbpApi}/zendesk/ticket/${this.ticketId}/cancel`,
          {
            requesterId: this.requesterId,
            ticketNote: `Cancellation via Zendesk Email Click: ${this.ticketId}`,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.data.message !== 'Success') {
          throw new Error('Something went wrong');
        }
        this.populateUserValues(response.data.data);
        return response;
      } catch (error) {
        console.error(error);
        this.error = true;
        return;
      } finally {
        this.messageLanguage();
        this.isBusy = false;
        this.resizeWindow();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background-color: #f7f4f4;
}
.stage__title {
  font-size: 23px;
  font-family: 'Lato', sans-serif;
  font-weight: 900 !important;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;
  color: #2b2b2b;
}
.stage_title--sub {
  font-size: 18px;
  font-family: 'Lato', sans-serif;
  padding: 0 1rem 0;
  font-weight: 400;
  margin: 0;
  margin-bottom: 2.9rem;
  color: #8c8c8c;
  letter-spacing: 0.03rem;
}
.stage_title--sub h1 {
  margin-bottom: 0.67em;
}
.bolder {
  font-weight: bold;
  font-size: 18px;
}
.body {
  padding: 0;
  margin-bottom: 0.5rem;
}
.body-padding {
  padding: 0;
  margin-bottom: 2rem;
}

@media (min-width: 641px) {
  .stage__title {
    font-size: 42px;
  }
}

@media (min-width: 832px) {
  .stage__title {
    padding-top: 0;
    margin-top: -0.7rem;
  }
  .stage_title--sub {
    margin-top: 1.9rem;
    margin-bottom: 1.25rem;
    font-size: 18px;
  }
}
/* h3 {
  margin: 40px 0 0;
} */
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
